export { LanguageSwitcherComponent } from './language-switcher/language-switcher.component';
export { LanguageSwitcherMiniComponent } from './language-switcher-mini/language-switcher-mini.component';
